import { NavLink } from "react-router-dom";
import { styled } from "styled-components";

function Menubar() {
  return (
    <Ul>
      <Li>
        <NavLink
          className={({ isActive }) => (isActive ? "active" : "")}
          to="/"
        >
          Home
        </NavLink>
      </Li>
      {/* <Li>
        <NavLink
          className={({ isActive }) => (isActive ? "active" : "")}
          to="/blogs"
        >
          Blogs
        </NavLink>
      </Li> */}
      <Li>
        <NavLink
          className={({ isActive }) => (isActive ? "active" : "")}
          to="/recruit"
        >
          Join Us
        </NavLink>
      </Li>
      <Li>
        <NavLink
          className={({ isActive }) => (isActive ? "active" : "")}
          to="/about"
        >
          About
        </NavLink>
      </Li>
    </Ul>
  );
}

export default Menubar;

const Ul = styled.ul`
  display: flex;
  gap: 1px;
  height: 100px;
`;

const Li = styled.li`
  line-height: 100px;
  > a {
    border: none;
    text-decoration: none;
    color: #000;
    display: block;
    padding: 0 20px;
    &.active {
      color: #0070EB;
      font-weight: bold;
    }
    &:hover {
      color: #0070EB;
    }
  }
`;
